export const appLookupUrlFormat = '{0}/api/m365AppDefinition/{1}';
//# sourceMappingURL=api.js.map